require('!!raw-loader!/builds/383345/v2/src/index.html');